/**
 * created by athukorala on 9/11/19
 */
import React, {Component} from 'react';
import './Super_ViewMeetingsReports_Visitors.css'
import Modal from "../../../../components/Modal/Modal";
import {Col, Row} from "reactstrap";
import {MDBDataTable} from "mdbreact";
import {Icon, Spin, Tooltip} from "antd";
import * as TableHeader from "../../../../store/Reducer/DropDownConst";
import Cookies from "js-cookie";
import axiosVisitoTags from "../../../../axios/axios_visitortag";
import * as common from "../../../../const/Common/CommonFunc";
import Spinner from "../../../../components/Spinner/Spinner";
import $ from "jquery";
import Download from "../../../../components/Button/DownloadbleButton";
import apiConfig from "../../../../axios/axios_api_services";

class App extends Component {
  state = {
    data: [],
    spin: true
  };

  componentDidMount(){
    this.getAllDetails();
    this.fillData();
    $('#meeting-visitors-reports-table').bind('DOMSubtreeModified', this.fillData.bind(this));
  }

  fillData = () =>{
    $("#meeting-visitors-reports-table > tbody > tr").each(function () {
      if($(this).find('td').eq(1).text() === "OVERDUE"){
        $(this).css("background-color", "rgb(255, 211, 211)") //#ff9696

      }
      if($(this).find('td').eq(1).text() === "CHECKED_OUT"){
        $(this).css("background-color", "rgb(251, 253, 215)") //rgb(249, 255, 150)
      }

      if($(this).find('td').eq(1).text() === "CHECKED_IN"){
        $(this).css("background-color", "rgb(214, 236, 247)") //rgb(175, 229, 255)
      }
    });
  };

  getAllDetails = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axiosVisitoTags.get(apiConfig.MEETING_VISITOR_REPORT(this.props.id), {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({
            data: response.data.content,
            spin: false
          })
        }else {
          common.notifyMessage(response.data.message);
          this.setState({
            data: [],
            spin: false
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllDetails();
        }
      });
  };

  render() {
    let rows = [];
    if(this.state.data.length !== 0){
      this.state.data.map((data,index)=>{
        const obj = {
          _:<Spinner type={1} size={30} isColor={data.tagColour !== null} color={data.tagColour}/>,
          _0:data.status,
          _1:data.visitorName,
          _2:data.visitorMobile,
          _3:data.visitorIdentity,
          _4:data.visitorEmail,
          _5:data.company,
          _6:data.checkedIn,
          _7:data.checkedOut,
          _8:data.passNumber,
          _9:data.activatedPackage,
          _10:data.vehicleNumber,
          _11:data.remark ? data.remark.length < 20 ? <p>{data.remark}</p> :
            <Tooltip placement="topLeft" title={data.remark}>
              <p>{data.remark.substring(0,19)+".."}</p>
            </Tooltip>: "",
          _12:data.enableOverdueSMS ? "Enable" : "Not Enable",
        };
        rows.push(obj);
      })
    }
    let data = {columns: TableHeader.superMeetingReportViewVisitors, rows: rows};
    return (
      <Modal isOpen={true} toggle={() => this.props.closeModal(false, 0)} size="lg" header="Meeting visitors">
        <Spin spinning={this.state.spin} delay={10}
              indicator={<Icon type="loading" style={{fontSize: 24}} spin/>}>
          <Row>
            <Col>
                  <div className={"super-meeting-report-visitors-wrapper"}>
                    <Download right={true} data={this.state.data} filename={"tags-meeting-visitor.csv"} userType={"MEETING_VISITORS"}/>
                    <MDBDataTable
                      id={"meeting-visitors-reports-table"}
                      searching={true}
                      searchLabel={"Search Visitor"}
                      responsive
                      responsiveSm
                      responsiveMd
                      responsiveLg
                      responsiveXl
                      bordered
                      hover
                      data={data}/>
                  </div>
            </Col>
          </Row>
        </Spin>

      </Modal>
    );
  }
}

export default App;
